<template>
  <div
    :class="verticalPadding"
    class="overflow-auto md:overflow-hidden flex-1 flex flex-col items-stretch justify-between gap-8"
  >
    <div :class="horizontalPadding" class="md:overflow-auto grid">
      <div v-if="title && title.length > 0" class="whitespace-pre-line text-base text-darkBlueG0 font-bold">
        {{ title }}
      </div>
      <div v-if="desc && desc.length > 0" class="mt-2 whitespace-pre-line text-sm text-blackG3">
        {{ desc }}
      </div>
      <slot />
    </div>
    <div :class="horizontalPadding" class="grid">
      <div class="flex flex-wrap items-stretch justify-center gap-2.5">
        <el-button v-if="backButtonOnClick" data-testid="back" class="white_button !m-0" @click="backButtonOnClick">
          {{ $t('common.button.back') }}
        </el-button>
        <el-button v-if="nextButtonOnClick" data-testid="next" class="blue_button !m-0" @click="nextButtonOnClick">
          {{ $t(nextButtonLabel) }}
        </el-button>
      </div>
      <div v-if="errorText && errorText.length > 0" class="mt-5 text-sm text-redG0 whitespace-pre-line">
        {{ $t(errorText) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterForm',
  props: {
    title: { type: String, default: '' },
    desc: { type: String, default: '' },
    nextButtonLabel: { type: String, default: 'common.button.next' },
    nextButtonOnClick: { type: [Function, null], default: null },
    backButtonOnClick: { type: [Function, null], default: null },
    errorText: { type: String, default: '' },
    horizontalPadding: { type: String, default: 'px-5 md:px-10' },
    verticalPadding: { type: String, default: 'py-4 md:py-10' }
  }
};
</script>
